module.exports = __webpack_public_path__ + "assets1783936157458/img/home-img.ff28be9e.jpg";